export default class Timer {

    _timerID;
    _ms;
    _handle;
    _once;

    _state;

    static get START(){
        return 0;
    }

    static get STOP(){
        return 1;
    }

    get state(){
        return this._state;
    }

    _getSetFunction(){
        return this._once? setTimeout : setInterval;
    }

    _getClearFunction(){
        return this._once? clearTimeout : clearInterval;
    }

    constructor(handle, ms, once = false) {
        this._ms = ms;
        this._handle = handle;
        this._once = once;
        this._state = Timer.STOP;
    }

    start() {
        if(!this._timerID && this._handle){
            this._timerID = this._getSetFunction()(() => this._handle(), this._ms);
            this._state = Timer.START;
        }
    }

    stop() {
        if(this._timerID){
            this._getClearFunction()(this._timerID);
            this._timerID = null;
            this._state = Timer.STOP;
        }
    }
}
